module.exports = __webpack_public_path__ + "static/media/JiraCloudCapture1.1f0ed415.JPG";